import { Component } from '@angular/core';

@Component({
  selector: 'app-explore-tools',
  imports: [],
  templateUrl: './explore-tools.component.html',
  styleUrl: './explore-tools.component.css'
})
export class ExploreToolsComponent {

}
